//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            property: {},
            settings: {},
            regionalManagers: [],
            managers: [],
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            percent: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '%',
                precision: 2,
                masked: false
            },
            steps: [],
            currentStep: 0,
            enterManually: false,
            uploadFile: false,
            buildings: [{
                name: '',
                structure_type_id: '',
                structure_category_id: ''
            }],
            propertyAmenitiesSelected: [],
            unitAmenitiesSelected: [],
            structureTypes: [],
            unitAmenities: [],
            propertyAmenities: [],
            loaded: false,
            feeAmounts: [],
            defaultCodes: [],
            glAccountOptions: []
        };
    },


    computed: {

        //Only show amenities in either the left or right column

        propertyAmenitiesFiltered: function propertyAmenitiesFiltered() {
            var $el = this;
            return $el.propertyAmenities.filter(function (amen) {
                return !$el.propertyAmenitiesSelected.find(function (elem) {
                    return elem.id === amen.id;
                });
            });
        },
        unitAmenitiesFiltered: function unitAmenitiesFiltered() {
            var $el = this;
            return $el.unitAmenities.filter(function (amen) {
                return !$el.unitAmenitiesSelected.find(function (elem) {
                    return elem.id === amen.id;
                });
            });
        }
    },

    mounted: function mounted() {},
    created: function created() {
        var _this = this;

        var $el = this;
        Event.$on('add-new-property', function () {
            _this.refreshData();

            Event.$emit('show-full-modal');
            $el.loaded = true;
        });

        Event.$on('step-loaded', this.stepLoaded);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('add-new-property');
        Event.$off('step-loaded');
    },

    methods: {
        stepLoaded: function stepLoaded(step) {
            this.steps.push(step);
        },
        refreshData: function refreshData() {
            var $el = this;
            $el.getBuildingOptions();
            $el.getPropertyOptions();
            this.loading = false;

            Promise.all([$el.getMangers(), $el.getBuildingOptions(), $el.getPropertyOptions()], $el.getDefaultCodes(), $el.getGLAccounts()).then(function () {
                $el.loading = false; //not working for some reason
            });
        },
        getMangers: function getMangers() {
            var $el = this;

            axios.get('/prototype/properties/managers').then(function (response) {
                if (response.data) {
                    $el.regionalManagers = response.data.regionalManagers;
                    $el.managers = response.data.managers;
                    return true;
                }
            });
        },
        getDefaultCodes: function getDefaultCodes() {
            var $el = this;

            axios.get('/prototype/properties/defaultGLCodes').then(function (response) {
                if (response.data) {
                    var rawDefaultCodes = response.data;
                    var newCodeArray = {};
                    rawDefaultCodes.forEach(function (code) {
                        newCodeArray[code.name] = code;
                    });

                    $el.defaultCodes = newCodeArray;
                    return true;
                }
            });
        },
        getGLAccounts: function getGLAccounts() {
            var $el = this;

            axios.get('/prototype/properties/glAccounts').then(function (response) {
                if (response.data) {
                    $el.glAccountOptions = response.data;
                    return true;
                }
            });
        },
        getBuildingOptions: function getBuildingOptions() {
            var $el = this;
            axios.get('/prototype/buildings/options').then(function (response) {
                if (response.data) {
                    $el.structureTypes = response.data.types;
                    return true;
                }
                return false;
            });
        },
        getPropertyOptions: function getPropertyOptions() {
            var $el = this;
            axios.get('/prototype/properties/options').then(function (response) {
                if (response.data) {

                    $el.unitAmenities = response.data.unitAmenities;
                    $el.propertyAmenities = response.data.propertyAmenities;
                    return true;
                }

                return false;
            });
        },
        addBuilding: function addBuilding(idx) {
            this.buildings.push({
                name: '',
                category: '',
                structure: ''
            });
        },
        next: function next() {
            this.currentStep++;
            this.steps.forEach(function (step) {
                step.$data.isActive = false;
            });
            this.steps[this.currentStep].$data.isActive = true;
            document.querySelector(".modal-wrapper").scrollTo({ top: 0 });
        },
        back: function back() {
            this.currentStep--;
            this.steps.forEach(function (step) {
                step.$data.isActive = false;
            });
            this.steps[this.currentStep].$data.isActive = true;
            document.querySelector(".modal-wrapper").scrollTo({ top: 0 });
        },
        removeAmenity: function removeAmenity(index) {
            this.propertyAmenitiesSelected.splice(index, 1);
        },
        addAmenity: function addAmenity(index) {
            this.propertyAmenitiesSelected.push({
                name: this.propertyAmenitiesFiltered[index].name,
                id: this.propertyAmenitiesFiltered[index].id
            });
        },
        removeAmenityUnit: function removeAmenityUnit(index) {
            this.unitAmenitiesSelected.splice(index, 1);
        },
        addAmenityUnit: function addAmenityUnit(index) {
            this.unitAmenitiesSelected.push({
                name: this.unitAmenitiesFiltered[index].name,
                id: this.unitAmenitiesFiltered[index].id
            });
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        convertFormDataToJSON: function convertFormDataToJSON(formData) {
            var object = {};
            formData.forEach(function (value, key) {
                object[key] = value;
            });

            return JSON.stringify(object);
        },
        save: function save() {

            var self = this;

            var action = "/prototype/properties";
            var amenitiesData = this.convertFormDataToJSON(new FormData(document.querySelector("#amenities-form")));
            var bankAccountData = this.convertFormDataToJSON(new FormData(document.querySelector("#bank-account-form")));
            var codesData = this.convertFormDataToJSON(new FormData(document.querySelector("#codes-form")));

            //temporary until we store the user ID like we probably should instead of just the name as a string
            if (this.property.regionalManager) {
                this.property.regional_manager_name = this.property.regionalManager.full_name;
            }

            if (this.property.manager) {
                this.property.manager_name = this.property.manager.full_name;
            }

            var data = {
                property: JSON.stringify(this.property),
                buildings: JSON.stringify(this.buildings),
                settings: JSON.stringify(this.settings),
                gl_setup: codesData,
                defaultCodes: this.defaultCodes,
                bankAccount: bankAccountData,
                amenities: JSON.stringify(this.propertyAmenitiesSelected.concat(this.unitAmenitiesSelected))
            };

            axios.post(action, data).then(function (response) {
                $el.loading = false;
                $el.active = false;
                Event.$emit('propertyAdded', response.data.property);
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/NewPropertyWizard.vue
// module id = HcEE
// module chunks = 0 1